export type BadgeVariant = 'main' | 'guardian';

export const badgeVariantToClassName: Record<BadgeVariant, string> = {
    main: 'bg-vanillaYellow text-woodyBrown',
    guardian: 'bg-blue-100 text-blue-700',
};
